<template>
  <v-app
    id="portal"
    v-bind:class="{ collapsed: $store.getters.getSidebarOpen }"
  >
    <app-sidebar
      :windowWidth="windowWidth"
      :themeLoaded="themeLoaded"
    ></app-sidebar>
    <app-header :windowWidth="windowWidth"></app-header>

    <v-main>
      <v-container fluid>
        <div v-if="portalBannerVisible" class="portal-banner-wrap">
          <portal-banner
            :notification="portalBannerNotification"
            :visible="portalBannerVisible"
            @dismiss="dismissPortalBanner"
          />
        </div>
        <v-row>
          <v-col>
            <slot />
          </v-col>
        </v-row>
      </v-container>
      <org-add-edit-modal />
    </v-main>
  </v-app>
</template>
<script type="text/javascript">
import { mapGetters, mapMutations } from 'vuex';
import constants from '../constants/resolutions-constants';
import Header from './shared/header.vue';
import Sidebar from './shared/sidebar.vue';
import OrgAddEditModal from "../components/organizations/organization-new-edit.vue";
import { mobileCheck } from '../utils/mobileCheck';

import NotificationsService from '../services/notifications';
import PortalBanner from '../components/shared/portal-banner.vue';
import { selectPortalBannerNotification, getBannerDismissKey } from '../utils/portal-notification-banner';

export default {
  data() {
    return {
      themeLoaded: false,
      sm: constants.IPAD_PORTRAIT,
      windowWidth: document.documentElement.clientWidth,
      portalBannerNotification: null,
      portalBannerVisible: false,
    };
  },
  components: {
    'app-header': Header,
    'app-sidebar': Sidebar,
    'org-add-edit-modal': OrgAddEditModal,
    'portal-banner': PortalBanner,
  },

  computed: {
    ...mapGetters('layout', ['getIsMobile',]),
  },
  mounted() {
    this.setIsMobile(mobileCheck());
    if (this.getIsMobile && window.innerWidth <= constants.IPAD_PORTRAIT) {
      this.setIsMobileipadPortrait(true);
    } else {
      this.setIsMobileipadPortrait(false);
    }
    this.setDeviceWidth(window.innerWidth);
    window.addEventListener('resize', this.onResize);
    this.loadPortalBanner();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    ...mapMutations('layout', [
      'setDeviceWidth',
      'setIsMobile',
      'setIsMobileipadPortrait',
    ]),
    async loadPortalBanner() {
      try {
        const notifications = await NotificationsService.getActiveNotifications();
        const selected = selectPortalBannerNotification(notifications);
        if (!selected) {
          this.portalBannerNotification = null;
          this.portalBannerVisible = false;
          return;
        }

        const dismissKey = getBannerDismissKey(selected.id);
        const dismissed = sessionStorage.getItem(dismissKey);
        if (dismissed) {
          this.portalBannerNotification = selected;
          this.portalBannerVisible = false;
          return;
        }

        this.portalBannerNotification = selected;
        this.portalBannerVisible = true;
      } catch (e) {
        this.portalBannerNotification = null;
        this.portalBannerVisible = false;
      }
    },
    dismissPortalBanner() {
      try {
        const id = this.portalBannerNotification && this.portalBannerNotification.id;
        if (id) {
          sessionStorage.setItem(getBannerDismissKey(id), '1');
        }
      } catch (e) {
        // ignore storage access errors
      }
      this.portalBannerVisible = false;
    },
    onResize(event) {
      this.setIsMobile(mobileCheck());
      if (
        this.getIsMobile &&
        event.target.innerWidth <= constants.IPAD_PORTRAIT
      ) {
        this.setIsMobileipadPortrait(true);
      } else {
        this.setIsMobileipadPortrait(false);
      }
      this.windowWidth = event.target.innerWidth;
      this.setDeviceWidth(event.target.innerWidth);
    },
  },
};
</script>

<style lang="scss" type="text/css" scoped>
.portal-banner-wrap {
  margin: 12px 0;
}
</style>